"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nav = exports.NavItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@chakra-ui/react");
const react_router_dom_1 = require("react-router-dom");
const react_2 = require("@chakra-ui/react");
const __1 = require("../..");
function NavItem({ path, label, icon }) {
    const resolved = (0, react_router_dom_1.useResolvedPath)(path);
    const isActive = (0, react_router_dom_1.useMatch)({ path: resolved.pathname, end: true });
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, Object.assign({ to: path }, { children: (0, jsx_runtime_1.jsxs)(react_2.HStack, Object.assign({ m: 0, borderRight: isActive ? "3px solid var(--chakra-colors-lifted-green-500)" : "" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Center, Object.assign({ p: 3 }, { children: (0, jsx_runtime_1.jsx)(react_2.Icon, { as: icon, "aria-label": label, bg: "white", color: isActive ? "lifted.green.500" : "black" }) })), (0, jsx_runtime_1.jsx)(react_2.Text, Object.assign({ fontWeight: isActive ? "bold" : "" }, { children: label }))] })) }), path));
}
exports.NavItem = NavItem;
function Nav({ navItems }) {
    return ((0, jsx_runtime_1.jsxs)(react_1.Stack, Object.assign({ boxShadow: "xl", h: "100vh" }, { children: [(0, jsx_runtime_1.jsx)(react_1.Image, { boxSize: "6rem", src: __1.logoSvg, alt: "Lifted Logo", p: 3 }), navItems.map(NavItem)] })));
}
exports.Nav = Nav;
